import React, { useRef, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography, Box, IconButton
} from "@mui/material";
import { Close} from '@mui/icons-material';


export const ModalBasic = ({ open, onClose, title, content }) => {
  const descriptionElementRef = useRef(null);

  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.scrollTop = 0;
      }
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      maxWidth="lg"
    >
      <DialogTitle id="scroll-dialog-title">{title}</DialogTitle>
      <Box position="absolute" top={0} right={0}>
          <IconButton onClick={() => onClose()}>
              <Close />
          </IconButton>
      </Box>

      <DialogContent dividers={true}>
        <DialogContentText
          id="scroll-dialog-description"
          ref={descriptionElementRef}
          tabIndex={-1}
        >
          <div style={{whiteSpace: "pre-wrap", padding: '10px'}}>
            {content.split('\n').map((item, idx) => {
              return (
                  <Typography component='p' key={idx}>&nbsp; {item}</Typography>
              )})
            }
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
